export default (theme) => ({
  radioBtn: {
    margin: '10px 40px 0 0',
    '& .MuiIconButton-root': {
      padding: '0 5px',
    },
  },
  radioLabel: {
    color: theme.palette.font.main,
  },
  activeRadioLabel: {
    color: '#000000',
  },
  wrapper: {
    padding: 10,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    maxHeight: 337,
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      maxHeight: 200,
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: 140,
    },
  },
  slot: {
    margin: 5,
    minHeight: 55,
    borderRadius: 25,
    width: 'calc(100% / 3 - 10px)',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% / 2 - 10px)',
    },
  },
  timeSlotCaption: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectorWrapper: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: 23,
    [theme.breakpoints.down('md')]: {
      overflow: 'visible',
      border: 'none',
    },
  },
  fieldSet: {
    width: '100%',
  },
});
